// extracted by mini-css-extract-plugin
export default {"container":"index-module--container--86f40","layout":"index-module--layout--ac39b","content":"index-module--content--1cd64","paragraph":"index-module--paragraph--92959"};